export default __webpack_public_path__ + "static/media/noVacanciesIcon.f91b365b.svg";